import React from "react";
import { TextInputLabel, Checkbox } from "components/Form";

const GDPROptIn = props => {
  return (
    <TextInputLabel>
      <Checkbox
        name="user[gdpr_opt_in]"
        onChange={props.onOptIn}
        checked={props.gdprOptIn}
        value={props.gdprOptIn}
        className={props.className}
      />
      I would like to receive SolarWinds promotional communications about
      products, services and events.
    </TextInputLabel>
  );
};

export default GDPROptIn;
